<template>
  <div class="comp-se-card" v-show="roles.length">
    <div class="se-nav">
      <div v-for="(item, i) in navData" :key="item.link" :class="['header-nav', navActive === i ? 'navActive' : '']" @click="handleNav(i, item)">
        <span v-if="i != 0" class="nav-leftline"></span>
        <span class="nav-text">
          <i :class="['iconfont', item.icon, 'menu_icon']"></i>
          {{ item.message }}
        </span>
      </div>
    </div>
    <div class="se-content">
      <div class="content" v-for="item in data" :key="item.link">
        <div @click="handleEntrance(item.link)">
          <div class="se-box">
            <div class="se-icon">
              <img @error="imgError" :src="item.icon" alt="" />
            </div>
            <span class="se-message">{{ item.message }}</span>
          </div>
        </div>
      </div>
      <div class="placeholder" v-for="v in 5" :key="v"></div>
    </div>
  </div>
</template>

<script>
import Mgr from "../services/SecurityService";
export default {
  name: "main-entrance-card",
  data() {
    return {
      roles: [],
      userMgr: new Mgr(),
      isLogin: false,
      navActive: 0,
      flag: true,
      navData: [
        {
          id: "Production",
          icon: "iconshengchanguanli",
          message: "生产实践管理",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/dashboard?module=Production",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          id: "Teaching",
          icon: "iconjiaoxueyunhang",
          message: "教学运行",
          iconBackground: "#5CC7CF",
          link: "http://dev.ic.ve-city.com/admin/#/dashboard?module=Teaching",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          id: "Research",
          icon: "iconyingyongjishukaifa",
          iconBackground: "#F2AF50",
          message: "应用技术开发项目",
          link: "http://dev.ic.ve-city.com/admin/#/dashboard?module=Research",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          id: "Innovate",
          icon: "iconxueshengchuangxinchuangye",
          message: "学生创新创业",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/dashboard?module=Innovate",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          id: "Translate",
          icon: "iconchengguozhuanhua",
          iconBackground: "#5CC7CF",
          message: "成果转化",
          link: "http://dev.ic.ve-city.com/admin/#/dashboard?module=Translate",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        }
      ],
      data: [],
      moreMenu: {
        icon: require("../assets/entrance/更多.png"),
        message: "更多",
        iconBackground: "#52A8E5",
        link: "http://dev.ic.ve-city.com/admin/#/dashboard",
        meta: {
          roles: [
            "student",
            "teacher",
            "majormanager",
            "expert",
            "college",
            "datamanager",
            "enterprise",
            "school",
            "government",
            "admin",
            "apprentice"
          ]
        }
      },
      allMenu: [
        {
          parent: "Production",
          icon: require("../assets/entrance/production/专场招聘会.png"),
          message: "生产实践管理",
          link: "http://dev.ic.ve-city.com/admin/#/dashboard?module=Production",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/线上宣讲会.png"),
          message: "线上宣讲会",
          link: "http://dev.ic.ve-city.com/admin/#/preach/",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/基地管理.png"),
          message: "基地管理",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/practice-base/base-manage",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/基地编排.png"),
          message: "基地编排",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/practice-base/base-arrange",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/基地申请.png"),
          message: "基地申请",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/practice-base/base-apply",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/基地使用分析.png"),
          message: "基地使用分析",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/practice-base/statistics",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/实习计划.png"),
          message: "实习计划",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/internship-enterprise/internship-plan/list",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/转岗审批.png"),
          message: "转岗审批",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/internship-enterprise/transfer-post/list",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/生产日报.png"),
          message: "生产日报",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/internship-report/daily-commit/list",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/生产月报.png"),
          message: "生产月报",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/internship-report/month-manage",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Production",
          icon: require("../assets/entrance/production/工时统计.png"),
          message: "工时统计",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/internship-report/duration-statistics",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        // 教学
        {
          parent: "Teaching",
          icon: require("../assets/entrance/teaching/学分管理制度.png"),
          message: "学分管理制度",
          link:
            "http://dev.ic.ve-city.com/admin/#/Credit/CreditManagement/List",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Teaching",
          icon: require("../assets/entrance/teaching/学分管理成果.png"),
          message: "学分管理成果",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/Credit/CreditAchievement/List",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Teaching",
          icon: require("../assets/entrance/teaching/学分银行对接规则.png"),
          message: "学分银行对接规则",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/Credit/credit-rule/list",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Teaching",
          icon: require("../assets/entrance/teaching/岗位分析.png"),
          message: "岗位行业分析",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/jobanalysis/list",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "school",
              "government",
              "admin"
            ]
          }
        },
        // 研究
        {
          parent: "Research",
          icon: require("../assets/entrance/research/专家导师.png"),
          message: "专家导师",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/ServicesManagement/Expert",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/企业培训.png"),
          message: "企业培训",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/services-management/train",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/岗位实践.png"),
          message: "岗位实践",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/ServicesManagement/PracticeJob",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/活动考核.png"),
          message: "活动考核",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/service-achievement/exam-result",
          meta: {
            roles: [
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/问卷调查.png"),
          message: "问卷调查",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/service-achievement/questionnaire",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/问答服务.png"),
          message: "问答服务",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/services-technology/question-answer",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/专家展示.png"),
          message: "专家展示",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/ExpertManagement/Expert",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/专家订单.png"),
          message: "专家订单",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/expert-management/order/",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Research",
          icon: require("../assets/entrance/research/项目管理.png"),
          message: "项目管理",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/project-management/",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        // 双创
        {
          parent: "Innovate",
          icon: require("../assets/entrance/innovate/双创政策.png"),
          message: "双创政策",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/Innovate/InnovationPolicy",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Innovate",
          icon: require("../assets/entrance/innovate/路演信息.png"),
          message: "路演信息",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/roadshow/list",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Innovate",
          icon: require("../assets/entrance/innovate/赛事信息.png"),
          message: "赛事信息",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/MatchList",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Innovate",
          icon: require("../assets/entrance/innovate/双创项目.png"),
          message: "双创项目",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/innovation-project/",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Innovate",
          icon: require("../assets/entrance/innovate/投融资服务.png"),
          message: "投融资服务",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/investor/",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Innovate",
          icon: require("../assets/entrance/innovate/创业导师.png"),
          message: "双创导师",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/Innovate/Tutor",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Innovate",
          icon: require("../assets/entrance/innovate/赛事信息.png"),
          message: "创业联盟",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/League",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        // 转化 Translate
        {
          parent: "Translate",
          icon: require("../assets/entrance/translate/成果展示.png"),
          message: "成果展示",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/dashboard?module=Translate",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Translate",
          icon: require("../assets/entrance/translate/科研单位.png"),
          message: "科研单位",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/Achievement/Scientific",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Translate",
          icon: require("../assets/entrance/translate/体制机制.png"),
          message: "体制机制创新",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/Translate/AchievementPolicy",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Translate",
          icon: require("../assets/entrance/translate/惠企政策.png"),
          message: "惠企政策",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/SupportAndApply/PreferentialPolicies",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Translate",
          icon: require("../assets/entrance/translate/科技中介.png"),
          message: "科技中介",
          iconBackground: "#52A8E5",
          link: "http://dev.ic.ve-city.com/admin/#/Intermediary/Intermediary",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        },
        {
          parent: "Translate",
          icon: require("../assets/entrance/translate/成果转化支撑服务库.png"),
          message: "成果转化支撑服务库",
          iconBackground: "#52A8E5",
          link:
            "http://dev.ic.ve-city.com/admin/#/Intermediary/AchievementIntermediary",
          meta: {
            roles: [
              "student",
              "teacher",
              "majormanager",
              "expert",
              "college",
              "datamanager",
              "enterprise",
              "school",
              "government",
              "admin",
              "apprentice"
            ]
          }
        }
      ]
    };
  },
  created() {
    this.checkLogin();
  },
  // mounted() {
  //   this.handleNav(0, this.navData[0]);
  // },
  watch: {
    roles: {
      handler(val) {
        if (this.flag && val.length) {
          this.handleNav(0, this.navData[0]);
          this.flag = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    async checkLogin() {
      var isLogin = await this.userMgr.isLogin();
      this.isLogin = isLogin;
      if (this.isLogin) {
        const { roles } = await this.$store.dispatch("user/getInfo");
        this.roles = roles;
      }
    },
    handleNav(i, item) {
      this.navActive = i;
      // 渲染menuData
      this.data = [];
      this.allMenu.forEach(e => {
        if (e.parent == item.id) {
          this.roles.forEach(el => {
            if (e.meta.roles.indexOf(el) !== -1) {
              this.data.push(e);
            }
          });
        }
      });
      //超过9个的，显示更多
      if (this.data.length >= 11) {
        this.data = this.data.slice(0, 10);
        this.data.push(this.moreMenu);
      } else {
        // this.data.push(this.moreMenu);
      }
      // console.log(this.data);
    },
    handleEntrance(link) {
      window.location.href = link;
    }
  }
};
</script>

<style lang="scss" scoped>
.navActive {
  background: $primary-color;
  :hover {
    color: #ffffff !important;
  }
  .nav-text {
    color: #ffffff;
  }
  // border-radius: 8px 8px 8px 8px;
}
.se-nav {
  width: 100%;
  height: 64px;
  background: #ffffff;
  box-shadow: 0px 2px 11px 0px rgba(47, 84, 235, 0.1);
  border-radius: 8px;
  margin-top: -32px;
  position: relative;
  z-index: 9;
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  overflow: hidden;

  transform: scale(1);
  .header-nav {
    width: 236px;
    height: 64px;
    display: flex;
    flex-direction: row;
    color: #333333;
    transition: all 1s;
    :hover {
      color: $primary-color;
      cursor: pointer;
    }
    .nav-leftline {
      display: inline-block;
      width: 1px;
      height: 64px;
      background: #eeeeee;
    }
    .nav-text {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-weight: 600;
      .menu_icon {
        font-size: 16px;
        margin-right: 8px;
      }
    }
  }
}
.comp-se-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 40px;
}
.se-box {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 176px;
  height: 150px;
  background: #ffffff;
  border-radius: 4px;
  &:hover {
    width: 172px;
    height: 146px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(154, 168, 222, 0.2);
    border-radius: 4px;
    border: 2px solid $primary-color;
  }
  .se-null-box {
    height: 0;
  }
  .se-icon {
    width: 56px;
    height: 56px;
    padding: 24px 60px 24px 60px;
  }
  .se-message {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
}
.se-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  white-space: normal;
  cursor: pointer;
  .se-info {
    padding-top: 16px;
    padding-right: 24px;
  }
  .se-rightBox {
    padding-right: 0;
  }
  .content {
    width: 176px;
    height: 150px;
    margin-top: 24px;
  }
  .placeholder {
    width: 176px;
    height: 0;
  }
}
</style>
